import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { BatchstampService } from "../batchstamp.service";
import * as moment from "moment";

declare var $: any;

@Component({
  selector: "app-detail",
  templateUrl: "./details.component.html",
  styleUrls: ["./details.component.css"],
  providers: [],
})
export class DetailsComponent implements OnInit {
  id: number;
  detailsOrder: any = [];
  stampService: any = new Array();

  public doughnutChartLabels: string[] = [
    "Đã Kích Hoạt",
    "Chưa Kích Hoạt",
    "Trưng Bày",
    "Xác Thực/ Đã Bán",
    "Hủy Kích Hoạt",
    "Khóa",
  ];
  public doughnutChartData: number[] = [];
  public doughnutChartType: string = "doughnut";
  public doughnutChartColors: any[] = [
    {
      backgroundColor: [
        "#86c7f3",
        "#ffa1b5",
        "#ffe29a",
        "#a4c73c",
        "#b8436d",
        "#c1d6e1",
      ],
    },
    {
      borderColor: [
        "#86c7f3",
        "#ffa1b5",
        "#ffe29a",
        "#a4c73c",
        "#b8436d",
        "#c1d6e1",
      ],
    },
    {
      pointBackgroundColor: [
        "#86c7f3",
        "#ffa1b5",
        "#ffe29a",
        "#a4c73c",
        "#b8436d",
        "#c1d6e1",
      ],
    },
    {
      pointBorderColor: [
        "#86c7f3",
        "#ffa1b5",
        "#ffe29a",
        "#a4c73c",
        "#b8436d",
        "#c1d6e1",
      ],
    },
    {
      pointHoverBackgroundColor: [
        "#86c7f3",
        "#ffa1b5",
        "#ffe29a",
        "#a4c73c",
        "#b8436d",
        "#c1d6e1",
      ],
    },
    {
      pointHoverBorderColor: [
        "#86c7f3",
        "#ffa1b5",
        "#ffe29a",
        "#a4c73c",
        "#b8436d",
        "#c1d6e1",
      ],
    },
  ];
  public doughnutChartOption: any = {
    legend: {
      align: "center",
      position: "right",
    },
  };

  stamp_service: string = "";
  id_service: string = "";

  messageOrder = {
    chonggia: {
      xacthuc: "",
      canhbao: "",
      xacthuc_s: "",
      canhbao_s: "",
    },
    baohanh: {
      xacthuc: "",
      canhbao: "",
      xacthuc_s: "",
      canhbao_s: "",
    },
  };
  msgchonggia: boolean = false;
  msgbaohanh: boolean = false;
  // Message update message order
  MesageSuccessCG = "";
  MesageErrorCG = "";
  MesageSuccessBH = "";
  MesageErrorBH = "";

  data_service = [];

  show_chart = 0;

  // Search Mã tem
  matem: string = "";

  public FormSearch: FormGroup;
  public FormMesage: FormGroup;

  constructor(
    private service: BatchstampService,
    private activerouter: ActivatedRoute,
    fb: FormBuilder
  ) {
    this.FormSearch = fb.group({
      matem: [null, Validators.required],
    });
    this.FormMesage = fb.group({
      chonggia: fb.group({
        xacthuc: [null],
        canhbao: [null],
        xacthuc_s: [null],
        canhbao_s: [null],
      }),
      baohanh: fb.group({
        xacthuc: [null],
        canhbao: [null],
        xacthuc_s: [null],
        canhbao_s: [null],
      }),
    });

    this.id = this.activerouter.snapshot.params["id"];
    this.getDetailsOrder(this.id);
  }

  ngOnInit() {
    $("#sl_type_date").select2();
  }

  public getDetailsOrder(id) {
    this.show_chart = 0;
    this.service.getDetailsOrder(id).subscribe(
      (res) => {
        if (res.status == 200) {
          let status = this.Status(res.data.status);

          let serial = this.Serial(
            res.data.id_end,
            res.data.id_start,
            res.data.prefix
          );

          this.StampService(res.data.stamp_service);
          this.id_service = res.data.stamp_service;

          let obj = {
            id: res.data.id,
            name: res.data.name,
            quantity: res.data.quantity,
            counter: res.data.counter,
            status: status,
            created_at: moment(res.data.created_time * 1000).format(
              "DD/MM/YYYY"
            ),
            user_name: res.data.username,
            serial: serial,
            payment: res.data.status,
          };
          this.detailsOrder.push(obj);

          let request = {
            order_id: res.data.id,
          };
          this.getStampStatic(request);
          this.getMessageOrder(request);
        } else {
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  public getStampStatic(request) {
    this.service.GetStampStatic(request).subscribe(
      (res) => {
        if (res.status == 200) {
          this.doughnutChartData = [
            res.data.actived, // Đã Kích Hoạt
            res.data.not_actived, // Chưa Kích Hoạt
            res.data.sample, // Xuất Mẫu
            res.data.sold, // Xác Thực/ Đã Bán
            res.data.deactived, // Hủy
            res.data.restored, // Thu Hồi
          ];

          if (
            res.data.actived > 0 ||
            res.data.not_actived > 0 ||
            res.data.sample > 0 ||
            res.data.sold > 0 ||
            res.data.deactived > 0 ||
            res.data.restored > 0
          ) {
            this.show_chart = 1;
          }

          // // Đã Kích Hoạt
          this.doughnutChartLabels[0] += " ( " + res.data.actived + " )";
          // Chưa Kích Hoạt
          this.doughnutChartLabels[1] += " ( " + res.data.not_actived + " )";
          // Xuất Trưng Bày
          this.doughnutChartLabels[2] += " ( " + res.data.sample + " )";
          // Xác Thực/ Đã Bán
          this.doughnutChartLabels[3] += " ( " + res.data.sold + " )";
          // Hủy Kích Hoạt
          this.doughnutChartLabels[4] += " ( " + res.data.deactived + " )";
          // Thu Hồi
          this.doughnutChartLabels[5] += " ( " + res.data.restored + " )";

          // console.log(this.doughnutChartLabels);
        } else {
          console.log(res);
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  public getMessageOrder(request) {
    this.service.getMessageOrder(request).subscribe(
      (res) => {
        if (res.status == 200) {
          console.log(res.data);
          for (let _data of res.data) {
            if (_data.service_id == 1 || _data.service_id == 2) {
              this.messageOrder.chonggia.xacthuc = _data.message_success;
              this.messageOrder.chonggia.canhbao = _data.message_warning;
              this.messageOrder.chonggia.xacthuc_s = _data.message_sms_success;
              this.messageOrder.chonggia.canhbao_s = _data.message_sms_warning;
              this.msgchonggia = true;
            } else if (_data.service_id == 3) {
              this.messageOrder.baohanh.xacthuc = _data.message_success;
              this.messageOrder.baohanh.canhbao = _data.message_warning;
              this.messageOrder.baohanh.xacthuc_s = _data.message_sms_success;
              this.messageOrder.baohanh.canhbao_s = _data.message_sms_warning;
              this.msgbaohanh = true;
            }
          }
          console.log(this.messageOrder);
        } else {
          console.log(res);
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  // public submitFormSearch(value){
  //   this.matem = value.matem;
  //   this.service.findStamp(this.matem).subscribe(
  //     res => {
  //       if(res.status == 200){
  //         console.log(res);
  //       }else{
  //         console.log(res);
  //       }
  //     },
  //     error => {
  //       console.log(error);
  //     }
  //   )
  // }

  public updateMessage(orderId, service, request) {
    if (service == 1 || service == 2) {
      this.MesageSuccessCG = "";
      this.MesageErrorCG = "";
    } else if (service == 3) {
      this.MesageSuccessBH = "";
      this.MesageErrorBH = "";
    }

    this.service.updateMessage(orderId, service, request).subscribe(
      (res) => {
        if (res.status == 200) {
          if (service == 1 || service == 2) {
            this.MesageSuccessCG = "Cập Nhật Thông Báo Chống Giả Thành Công !";
            setTimeout(() => {
              this.MesageSuccessCG = "";
            }, 5000);
          } else if (service == 3) {
            this.MesageSuccessBH = "Cập Nhật Thông Báo Bảo Hành Thành Công !";
            setTimeout(() => {
              this.MesageSuccessBH = "";
            }, 5000);
          }
        } else {
          if (service == 1 || service == 2) {
            this.MesageErrorCG =
              "Cập Nhật Thông Báo Chống Giả Không Thành Công ! Vui Lòng Thử Lại Sau.";
            setTimeout(() => {
              this.MesageErrorCG = "";
            }, 5000);
          } else if (service == 3) {
            this.MesageErrorBH =
              "Cập Nhật Thông Báo Chống Giả Không Thành Công ! Vui Lòng Thử Lại Sau.";
            setTimeout(() => {
              this.MesageErrorBH = "";
            }, 5000);
          }
        }
      },
      (error) => {
        console.log(error);
        if (service == 1 || service == 2) {
          if (error.message) {
            this.MesageErrorCG = error.message;
          } else {
            this.MesageErrorCG =
              "Cập Nhật Thông Báo Chống Giả Không Thành Công ! Vui Lòng Thử Lại Sau.";
          }
          setTimeout(() => {
            this.MesageErrorCG = "";
          }, 5000);
        } else if (service == 3) {
          if (error.message) {
            this.MesageErrorBH = error.message;
          } else {
            this.MesageErrorBH =
              "Cập Nhật Thông Báo Bảo Hành Không Thành Công ! Vui Lòng Thử Lại Sau.";
          }
          setTimeout(() => {
            this.MesageErrorBH = "";
          }, 5000);
        }
      }
    );
  }

  public submidFormMessage(value) {
    // console.log(value);
    // console.log(this.id_service && this.detailsOrder);
    if (this.id_service && this.detailsOrder && this.data_service) {
      if (this.id_service.indexOf("1") != -1) {
        let request = {
          message_warning: value.chonggia.canhbao
            ? value.chonggia.canhbao
            : this.data_service[0].message_warning,
          message_success: value.chonggia.xacthuc
            ? value.chonggia.xacthuc
            : this.data_service[0].message_success,
          message_sms_warning: value.chonggia.canhbao_s
            ? value.chonggia.canhbao_s
            : this.data_service[0].message_sms_warning,
          message_sms_success: value.chonggia.xacthuc_s
            ? value.chonggia.xacthuc_s
            : this.data_service[0].message_sms_success,
          message_error: "",
        };
        this.updateMessage(this.id, "1", request);
      }

      if (this.id_service.indexOf("2") != -1) {
        let request = {
          message_warning: value.chonggia.canhbao
            ? value.chonggia.canhbao
            : this.data_service[1].message_warning,
          message_success: value.chonggia.xacthuc
            ? value.chonggia.xacthuc
            : this.data_service[1].message_success,
          message_sms_warning: value.chonggia.canhbao_s
            ? value.chonggia.canhbao_s
            : this.data_service[1].message_sms_warning,
          message_sms_success: value.chonggia.xacthuc_s
            ? value.chonggia.xacthuc_s
            : this.data_service[1].message_sms_success,
          message_error: "",
        };
        this.updateMessage(this.id, "2", request);
      }

      if (this.id_service.indexOf("3") != -1) {
        let request = {
          message_warning: value.baohanh.canhbao
            ? value.baohanh.canhbao
            : this.data_service[2].message_warning,
          message_success: value.baohanh.xacthuc
            ? value.baohanh.xacthuc
            : this.data_service[2].message_success,
          message_sms_warning: value.baohanh.canhbao_s
            ? value.baohanh.canhbao_s
            : this.data_service[2].message_sms_warning,
          message_sms_success: value.baohanh.xacthuc_s
            ? value.baohanh.xacthuc_s
            : this.data_service[2].message_sms_success,
          message_error: "",
        };
        this.updateMessage(this.id, "3", request);
      }
    }
  }

  public Serial(id_end, id_start, prefix) {
    id_end = id_end.toString();
    id_start = id_start.toString();
    let serial = "Chưa thanh toán";
    if (id_end && id_start && prefix) {
      let pad = "000000";
      let serial_start = pad.substring(0, 6 - id_start.length) + id_start;
      let serial_end = pad.substring(0, 6 - id_start.length) + id_end;
      serial = prefix + serial_start + " - " + prefix + serial_end;
    }
    return serial;
  }

  public Status(id_status) {
    let status = "";
    if (id_status == 0) {
      status = "Chưa thanh toán";
    } else if (id_status == 1) {
      status = "Thanh toán thành công";
    } else if (id_status == 2) {
      status = "Đang gen tem";
    } else if (id_status == 3) {
      status = "Hoàn thành gen";
    } else if (id_status == 4) {
      status = "Gen thất bại";
    } else if (id_status == 5) {
      status = "Hủy gen";
    }
    return status;
  }

  public StampService(data_stamp_service, i = 1) {
    this.service.getStampService().subscribe(
      (res) => {
        if (res.status == 200) {
          this.data_service = res.data;
          for (let _data of res.data) {
            this.stampService[_data.id] = _data.name;
          }
          if (data_stamp_service.indexOf("1") != -1) {
            if (this.stamp_service != "") {
              this.stamp_service += ", " + this.stampService[1];
            } else {
              this.stamp_service += this.stampService[1];
            }
          }
          if (data_stamp_service.indexOf("2") != -1) {
            if (this.stamp_service != "") {
              this.stamp_service += ", " + this.stampService[2];
            } else {
              this.stamp_service += this.stampService[2];
            }
          }
          if (data_stamp_service.indexOf("3") != -1) {
            if (this.stamp_service != "") {
              this.stamp_service += ", " + this.stampService[3];
            } else {
              this.stamp_service += this.stampService[3];
            }
          }
          if (data_stamp_service.indexOf("4") != -1) {
            if (this.stamp_service != "") {
              this.stamp_service += ", " + this.stampService[4];
            } else {
              this.stamp_service += this.stampService[4];
            }
          }
        } else {
          console.log(res);
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  // events
  public chartClicked(e: any): void {
    // console.log(e);
  }

  public chartHovered(e: any): void {
    // console.log(e);
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/batchstamp/details/details.component.ts